import { motion } from "framer-motion";

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-white/10 bg-black py-4" aria-label="HairByYaya services" data-testid="marquee">
    <motion.div className="flex w-max items-center" animate={{ x: ["0%", "-50%"] }} transition={{ repeat: Infinity, duration: 30, ease: "linear" }}>
      {[...items, ...items].map((item, i) => (
        <span key={`${item}-${i}`} className="mx-5 flex items-center gap-5 whitespace-nowrap font-serif text-lg italic text-white/90">
          {item}<span className="font-sans text-xs not-italic text-hotpink">✦</span>
        </span>
      ))}
    </motion.div>
  </div>
);
